<template>
  <div>
    <h1 class="page-header">{{ $t('holiday.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="ts-flex">
            <ts-date-picker-input v-model="cycle_year" format="YYYY" class="mr-2" />
            <ts-button color="primary" :waiting="generating" @click="generate()">{{
              $t('holiday.generate')
            }}</ts-button>
            <div class="ts-flex-grow"></div>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table :records="resources" :loading="loading">
          <template v-slot:thead>
            <thead>
              <tr>
                <th v-for="(column, key) in columns" :key="key">{{ column.name }}</th>
                <th style="text-align:center; width: 1px;">
                  <a href="#" v-tooltip="$t('tooltip.addItem')" class="text-primary" @click.prevent="showForm()">
                    <i class="fas fa-plus"></i>
                  </a>
                </th>
              </tr>
              <TableProgressBar v-show="loading" :columnLength="columns.length + 1" />
            </thead>
          </template>
          <template v-slot="{ record }">
            <td>{{ record.holiday_date }}</td>
            <td>{{ record.holiday_name_kh }}</td>
            <td>{{ record.holiday_name_en }}</td>
            <td>{{ record.holiday_description }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="$t('tooltip.edit')" class="text-primary" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'
import TableProgressBar from '@/components/common/TsTable/TableProgressBar'

export default {
  name: 'holiday',
  components: { FormComponent, TableProgressBar },
  data() {
    return {
      cycle_year: moment().year(),
      loading: false,
      generating: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/holiday', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.holiday.search
      },
      set(newValue) {
        this.$store.commit('hr/holiday/SET_SEARCH', newValue)
        this.$store.commit('hr/holiday/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('holiday.holidayDate'),
          sortKey: 'holiday_date'
        },
        {
          name: this.$t('holiday.holidayNameKh'),
          sortKey: 'holiday_name_kh'
        },
        {
          name: this.$t('holiday.holidayNameEn'),
          sortKey: 'holiday_name_en'
        },
        {
          name: this.$t('holiday.holidayDescription'),
          sortKey: 'holiday_description'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/holiday/fetch', { cycle_year: this.cycle_year, ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    generate() {
      this.generating = true
      this.$store
        .dispatch('hr/holiday/generate', { cycle_year: this.cycle_year })
        .then(response => {
          this.generating = false

          this.fetchData({ cycle_year: this.cycle_year })
        })
        .catch(error => {
          this.generating = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData,
          year: this.cycle_year
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    cycle_year: function(cycleYear) {
      this.fetchData({ cycle_year: cycleYear })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/holiday/RESET_STATE')
    next()
  }
}
</script>
